export default __webpack_public_path__ + "static/media/empty-questions.fcfd578c.svg";